import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseService } from '../../../services/base.service';
import { Layout } from '../models/layout';

@Injectable({
  providedIn: 'root'
})
export class LayoutService extends BaseService<Layout> {

  constructor(
    http: HttpClient,
    @Inject('BASE_URL') rootUrl: string            
  ) { 
    super(http,rootUrl,'Plasard/PlasardLayout');
  }
}
